<template>
  <div class="header-userinfo" @mouseenter="fnShowMenu" @mouseleave="fnHideMenu">
    <div class="user-wrap" @click="fnGoLerningCenter">
      <img
        :src="(user && user.headImgUrl) || DEFAULT_AVATAR"
        @error="fnImgError"
      />
      <p class="space"></p>
      <p class="user-name">
        {{ user && user.encryptedTelephone }}
      </p>
      <p class="space"></p>
      <img
        src="https://oss.lingjiang.com/webstatic/images/lingjiang/nav-user-dropdown-arrow.png"
        class="header-slide-img"
      />
    </div>
    <transition name="userdropdown-fade">
      <div class="header-slide" v-show="bIsMenuVisible">
        <!-- <div class="slide-userinfo">
          <img
            :src="(user && user.headImgUrl) || DEFAULT_AVATAR"
            @error="fnImgError"
          />
          <span>{{ user && user.encryptedTelephone }}</span>
        </div> -->
        <div class="slide-tabs">
          <p @click="fnGoLerningCenter">
            <span>
              <img
                src="https://oss.lingjiang.com/webstatic/images/lingjiang/learning-dropdown-icon/1.png?v=1.1"
                class="default-img"
              />
              <img
                src="https://oss.lingjiang.com/webstatic/images/lingjiang/learning-dropdown-icon/active1.png?v=1.1"
                class="active-img"
              />
              学习中心</span
            >
          </p>
          <p @click="fnGoReview">
            <span>
              <img
                src="https://oss.lingjiang.com/webstatic/images/lingjiang/learning-dropdown-icon/2.png?v=1.1"
                class="default-img"
              />
              <img
                src="https://oss.lingjiang.com/webstatic/images/lingjiang/learning-dropdown-icon/active2.png?v=1.1"
                class="active-img"
              />
              评审服务</span
            >
          </p>
          <p @click="fnGoLearningPerson">
            <span>
              <img
                src="https://oss.lingjiang.com/webstatic/images/lingjiang/learning-dropdown-icon/3.png?v=1.1"
                class="default-img"
              />
              <img
                src="https://oss.lingjiang.com/webstatic/images/lingjiang/learning-dropdown-icon/active3.png?v=1.1"
                class="active-img"
              />
              个人中心</span
            >
          </p>
          <p @click="loginOut">
            <span>
              <img
                src="https://oss.lingjiang.com/webstatic/images/lingjiang/learning-dropdown-icon/4.png?v=1.1"
                class="default-img"
              />
              <img
                src="https://oss.lingjiang.com/webstatic/images/lingjiang/learning-dropdown-icon/active4.png?v=1.1"
                class="active-img"
              />
              安全退出</span
            >
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import {
  STUDY_CENTER_URL,
  STUDY_REVIEW_URL,
  STUDY_PERSON_URL,
} from "@/api/api";
const DEFAULT_AVATAR =
  "https://oss.lingjiang.com/webstatic/images/lingjiang/new-default-headimg.png";
export default {
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      DEFAULT_AVATAR,
      bIsMenuVisible: false,
      timer: null,
    };
  },
  methods: {
    // 延迟显示隐藏，与el-dropdown效果一致
    fnShowMenu() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.bIsMenuVisible = true
      }, 250)
    },
    fnHideMenu() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.bIsMenuVisible = false
      }, 150)
    },
    /**
     * 退出登录
     */
    loginOut() {
      this.$emit("logout");
    },
    // 跳转学习中心
    fnGoLerningCenter() {
      window.open(STUDY_CENTER_URL);
    },
    // 跳转学习中心---个人中心
    fnGoLearningPerson() {
      window.open(STUDY_PERSON_URL);
    },
    // 跳转评审服务
    fnGoReview() {
      window.open(STUDY_REVIEW_URL);
    },
    fnImgError(e) {
      e.target.src = DEFAULT_AVATAR;
    },
    getDateNextYear(year = 1) {
      let date = new Date();
      date.setFullYear(date.getFullYear() + year);
      date.setDate(date.getDate() - 1);
      return new Date(date);
    },
  },
};
</script>
<style lang="scss" scoped>
  *,
  :after,
  :before {
    box-sizing: border-box;
    margin: 0;
  }
  a {
    display: block;
    width: 90px;
    height: 28px;
    opacity: 1;
    border-radius: 100px;
    background: rgba(255, 68, 61, 1);
    font-size: 14px;
    font-weight: 500;
    line-height: 28px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
  }

  .header-userinfo {
    margin-left: 40px;
    min-width: 100px;
    height: 65px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;

    .space {
      width: 5px;
    }

    .user-wrap {
      display: flex;
      align-items: center;
      cursor: pointer;
      &:hover {
        color: red;
      }
    }

    .user-name {
      max-width: 125px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
    }

    img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
    }

    .header-slide-img {
      width: 21px;
      height: 21px;
    }

    .header-slide {
      display: block;
      padding: 12px 0 !important;
      min-width: 170px;
      position: absolute;
      left: 50%;
      top: 56px;
      font-size: 14px;
      color: rgb(128, 128, 128);
      background-color: #fff;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      transform: translateX(-50%);
      z-index: 102;
      cursor: default;

      .slide-userinfo {
        display: flex;
        align-items: center;
        margin: 0 15px;
        margin-bottom: 8px;

        img {
          flex-shrink: 0;
          width: 32px;
          height: 32px;
          margin-right: 10px;
        }

        span {
          overflow: hidden;
          max-width: 150px;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-weight: 700;
        }
      }

      .slide-tabs {
        width: 100%;

        p {
          position: relative;
          height: 40px;
          line-height: 40px;
          text-align: center;
          cursor: pointer;
          span {
            position: relative;
            img {
              width: 20px;
              height: auto;
              position: absolute;
              left: -30px;
              top: 0;
            }
            .default-img {
              display: block;
            }
            .active-img {
              display: none;
            }
          }
        }

        p:hover {
          background: rgba(255, 68, 61, 0.03);
          color: #000;

          span {
            .default-img {
              display: none;
            }
            .active-img {
              display: block;
            }
          }
        }
      }
    }
  }

  .userdropdown-fade-enter-active,
  .userdropdown-fade-leave-active {
    transition: transform 300ms cubic-bezier(0.23, 1, 0.32, 1), opacity 300ms cubic-bezier(0.23, 1, 0.32, 1);
    transform-origin: center top;
  }
  .userdropdown-fade-enter,
  .userdropdown-fade-leave-to {
    opacity: 0;
    transform: translateX(-50%) scaleY(0) !important;
  }
  .userdropdown-fade-enter-to,
  .userdropdown-fade-leave {
    opacity: 1;
    transform: translateX(-50%) scaleY(1) !important;
  }
</style>




// WEBPACK FOOTER //
// src/components/user-dropdown.vue